import { useEffect, useState } from "react";
import "../styles/orange-seperator.scss";

const OrangeSeperator = (props) => {
  const [changeColor, setChangeColor] = useState(false);

  // Changes color based on passed props
  useEffect(() => {
    if (props.toWhite) {
      setChangeColor(true);
    } else {
      setChangeColor(false);
    }
  }, [props.toWhite]);

  return (
    <div className="orange-seperator">
      <div
        className={changeColor ? "orange-seperator__white-left-line" : "orange-seperator__left-line"}
        style={changeColor ? { backgroundColor: "#fff" } : { backgroundColor: "#fd8f40" }}
      ></div>
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={changeColor ? "orange-seperator__white-icon" : "orange-seperator__icon"}
      >
        <path
          d="M12.5 0C5.62988 0 0 5.62988 0 12.5C0 19.3701 5.62988 25 12.5 25C19.3701 25 25 19.3701 25 12.5C25 5.62988 19.3701 0 12.5 0Z"
          fill={changeColor ? "#fff" : "#fd8f40"}
        />
        <path
          d="M25 12.5C25 19.3701 19.3701 25 12.5 25V0C19.3701 0 25 5.62988 25 12.5Z"
          fill={changeColor ? "#fff" : "#fd8f40"}
        />
        <path
          d="M12.5 1.51367C6.43555 1.51367 1.51367 6.43555 1.51367 12.5C1.51367 18.5645 6.43555 23.4863 12.5 23.4863C18.5645 23.4863 23.4863 18.5645 23.4863 12.5C23.4863 6.43555 18.5645 1.51367 12.5 1.51367Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M23.4863 12.5C23.4863 18.5645 18.5645 23.4863 12.5 23.4863V1.51367C18.5645 1.51367 23.4863 6.43555 23.4863 12.5Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M20.4971 9.14463C20.6289 7.87021 20.1895 6.5957 19.2666 5.67295C18.3584 4.76465 17.0693 4.32524 15.8096 4.45708C15.0039 3.46099 13.7881 2.875 12.499 2.875C11.21 2.875 9.99409 3.46104 9.18848 4.45708C7.91406 4.3252 6.63965 4.76465 5.73145 5.67295C4.80859 6.5957 4.36914 7.87021 4.50093 9.14463C3.50483 9.93559 2.91895 11.1515 2.91895 12.4405C2.91895 13.7442 3.50483 14.96 4.50093 15.751C4.36914 17.0255 4.80859 18.2999 5.73145 19.2228C6.63965 20.131 7.91406 20.5704 9.18848 20.4385C9.99414 21.4346 11.21 22.0206 12.499 22.0206C13.7881 22.0206 15.004 21.4346 15.8096 20.4385C17.084 20.5704 18.3584 20.131 19.2666 19.2228C20.1895 18.2999 20.6289 17.0255 20.4971 15.751C21.4932 14.96 22.0791 13.7441 22.0791 12.4405C22.0791 11.1515 21.4932 9.93559 20.4971 9.14463Z"
          fill={changeColor ? "#fff" : "#fd8f40"}
        />
        <path
          d="M22.08 12.4424C22.08 13.7461 21.4941 14.9619 20.498 15.7529C20.6298 17.0274 20.1904 18.3018 19.2675 19.2247C18.3593 20.1329 17.0849 20.5723 15.8105 20.4404C15.0049 21.4365 13.7891 22.0225 12.5 22.0225V2.87695C13.7891 2.87695 15.0049 3.46294 15.8105 4.45903C17.0703 4.32715 18.3594 4.7666 19.2676 5.6749C20.1904 6.59766 20.6299 7.87217 20.4981 9.14658C21.4941 9.9375 22.08 11.1534 22.08 12.4424Z"
          fill={changeColor ? "#fff" : "#fd8f40"}
        />
        <path
          d="M21.1051 16.9143L13.582 13.6899L14.1585 12.3438L21.6816 15.5682L21.1051 16.9143Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M15.5927 22.1029L12.3984 14.1178L13.7588 13.5742L16.9532 21.5593L15.5927 22.1029Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M9.30508 21.8119L7.95898 21.2354L11.2492 13.5586L12.5953 14.1351L9.30508 21.8119Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M3.91079 16.6945L3.36719 15.3341L10.8566 12.3379L11.4002 13.6983L3.91079 16.6945Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M10.8764 12.5705L3.18457 9.27383L3.76104 7.92773L11.4529 11.2243L10.8764 12.5705Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M11.2759 11.4117L8.03223 3.30137L9.39268 2.75781L12.6363 10.8681L11.2759 11.4117Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M13.7172 11.427L12.3711 10.8505L15.7542 2.94336L17.1004 3.51987L13.7172 11.427Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M14.1234 12.5688L13.5469 11.2226L21.1429 7.9668L21.7194 9.31289L14.1234 12.5688Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M12.5 10.3027C11.2841 10.3027 10.3027 11.2841 10.3027 12.5C10.3027 13.7159 11.2841 14.6973 12.5 14.6973C13.7159 14.6973 14.6973 13.7159 14.6973 12.5C14.6973 11.2841 13.7159 10.3027 12.5 10.3027Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
        <path
          d="M14.6973 12.5C14.6973 13.7159 13.7159 14.6973 12.5 14.6973V10.3027C13.7159 10.3027 14.6973 11.2841 14.6973 12.5Z"
          fill={changeColor ? "#fd8f40" : "#fff"}
        />
      </svg>
      <div
        className={changeColor ? "orange-seperator__white-right-line" : "orange-seperator__right-line"}
        style={changeColor ? { backgroundColor: "#fff" } : { backgroundColor: "#fd8f40" }}
      ></div>
    </div>
  );
};

export default OrangeSeperator;
